// 给画板列表增加拼音
export async function setBoardsTitlePinyin(boards) {
  const pinyinjs = (await import("thepinyin.js")).default;

  return boards.map((board) => {
    let pinyin = [];
    for (let i = 0; i < board.title.length; i++) {
      const word = board.title[i];
      const letter = pinyinjs.py(word, pinyinjs.NOMARK);
      if (letter.length <= 0) {
        pinyin.push(word);
      } else {
        pinyin.push(Array.isArray(letter) ? letter[0] : letter);
      }
    }
    const item = {
      ...board,
      _pinyin: pinyin,
    };

    return item;
  });
}
// 通过拼音和创建时间排序
export default function sortBoardsByTitleAndCreateTime(boards) {
  return boards.sort((a, b) => {
    // _pinyin格式例子：[ "hua", "ban", "wang" ]
    const pinyinA = a._pinyin.join("").toLowerCase();
    const pinyinB = b._pinyin.join("").toLowerCase();
    if (pinyinA < pinyinB) {
      return -1;
    } else if (pinyinA > pinyinB) {
      return 1;
    } else {
      if (a.createAt < b.createAt) {
        return -1;
      } else if (a.createAt > b.createAt) {
        return 1;
      } else {
        return 0;
      }
    }
  });
}
